import React from "react";
import { useTheme } from "../../hooks/useTheme";
import "./ThemeToggle.css";

const ThemeToggle = () => {
  const { theme, toggleTheme } = useTheme();

  return (
    <button
      className={`theme-toggle ${theme === "dark" ? "dark" : "light"}`}
      onClick={toggleTheme}
      aria-label={`Zu ${theme === "dark" ? "hellem" : "dunklem"} Design wechseln`}
    >
      <div className="toggle-track">
        <div className="toggle-thumb">
          {theme === "dark" ? (
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
              <path
                d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"
                fill="currentColor"
              />
            </svg>
          ) : (
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
              <circle cx="12" cy="12" r="5" fill="currentColor" />
              <path
                d="m12 1-3 6 3-6zm0 18-3 6 3-6zm11-5-6-3 6 3zM7 12l-6-3 6 3zm5.5-6.5-1-5 1 5zm2-1-5-1 5 1zm-2 13-1 5 1-5zm2 1-5 1 5 1z"
                fill="currentColor"
              />
            </svg>
          )}
        </div>
      </div>
    </button>
  );
};

export default ThemeToggle;
